import { Form, Row, Col, FormGroup, Label, Input, Button, Modal, ModalHeader, ModalBody, ModalFooter, Breadcrumb, BreadcrumbItem, Container } from 'reactstrap';
import React, { useState, useRef, Component } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import PaletizadosVariantesTable from "../PaletizadosVariantes/PaletizadosVariantesTable"
import { PaletizadosVariantesView } from "./PaletizadosVariantesView"
import { PaletizadosVariantesDelete } from "./PaletizadosVariantesDelete"
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import CleaningServicesOutlinedIcon from '@mui/icons-material/CleaningServicesOutlined';
import CachedOutlinedIcon from '@mui/icons-material/CachedOutlined';
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';

import { Breadcrumbs } from '../General/Breadcrumbs';
import authService from '../api-authorization/AuthorizeService'
import VariantesProveedorService from "../PaletizadosVariantes/PaletizadosVariantesService"

export class PaletizadosVariantes_Index extends Component {
    static displayName = PaletizadosVariantes_Index.name;
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            loading: true,
            modalState: false,
            modalHeader: "Cargando",
            modalBody: () => { return (<div>Cargando</div>); },
            modalOperation: 'add',
            modalIsValid: false,
            searchModel: { nombre: "", codigo: "" },
            semana: {}
        };
        this.populateData = this.populateData.bind(this);
        this.modalBodyState = {};
        this.modalToggle = this.modalToggle.bind(this);
        this.setVariantes_onclick = this.setVariantes_onclick.bind(this);
        this.add_modal_guardar_onclick = this.add_modal_guardar_onclick.bind(this);
        this.edit_onclick = this.edit_onclick.bind(this);
        this.edit_modal_guardar_onclick = this.edit_modal_guardar_onclick.bind(this);
        this.delete_onclick = this.delete_onclick.bind(this);
        this.delete_modal_guardar_onclick = this.delete_modal_guardar_onclick.bind(this);
        this.setModalBodyState = this.setModalBodyState.bind(this);
        this.modalSubmit = this.modalSubmit.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.clean_onclick = this.clean_onclick.bind(this);

        this.downloadReport = this.downloadReport.bind(this);
    }

    componentDidMount() {
        this.populateData();
    }

    modalToggle() {
        this.setState({
            modalState: !this.state.modalState
        });
    }

    renderTable() {
        return (
            <div  >

                <Row>
                    <PaletizadosVariantesTable data={this.state.data} setVariantes_onclick={this.setVariantes_onclick} downloadReport_onclick={this.downloadReport} edit_onclick={this.edit_onclick} delete_onclick={this.delete_onclick} />
                </Row>
                <Modal isOpen={this.state.modalState} toggle={this.modalToggle}>
                    <ModalHeader toggle={this.modalToggle}>
                        {this.state.modalHeader}
                    </ModalHeader>
                    <ModalBody>
                        {this.state.modalBody}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={this.modalSubmit} disabled={!this.state.modalIsValid}>
                            {this.state.modalOperation == 'delete' ? <FormattedMessage id='Eliminar' /> : <FormattedMessage id='Guardar' />}
                        </Button>{' '}
                        <Button color="secondary" onClick={this.modalToggle}>
                            Cancelar
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }

    render() {
        let breadcrumbsData = this.state.loading
            ? <p></p>
            : <Breadcrumbs data={[
                { link: "/Semanas", message: "Semanas", active: true },
                { link: "/Semanas/" + this.state.semana.semana_Id + "/PaletizadosVariantes", message: "Varianti Semanal", active: false },
            ]} />;

        let contents = this.state.loading
            ? <p><em>Cargando...</em></p>
            : this.renderTable();

        return (
            <div style={{ width: '100%' }}>
                <h2><FormattedMessage id='VariantiSemanal' /></h2>
                {breadcrumbsData}

                <div className="viewContainerHeader ">
                    <div className="d-flex justify-content-start">
                        <div className="px-4 py-2"><FormattedMessage id='Semana' />: {this.state.semana.nombre}</div>
                        {/*<div className="px-4 py-2"><FormattedMessage id='Barco' />: {this.state.contenedorSemanal.barco}</div>*/}
                    </div>
                    <div className="d-flex justify-content-start">
                        {/*<div className="px-4 py-2"><FormattedMessage id='Producto' />: {this.state.proveedor.producto}</div>*/}
                        {/*<div className="px-4 py-2"><FormattedMessage id='Contenedor' />: {this.state.contenedorSemanal.contenedor}</div>*/}
                        {/*<div className="px-4 py-2"><FormattedMessage id='EtiquetaEspecial' />: {this.state.contenedorSemanal.etiquetaEspecial}</div>*/}
                    </div>
                </div>
                <div className="viewContainer-lg">
                    {contents}
                </div>

            </div>
        );
    }

    async populateData() {
        this.setState({ loading: true, semana: await this.load_semana() }, async () => {
            const token = await authService.getAccessToken();
            console.log("token", token);
            var queryString = '?semana_Id=' + this.state.semana.semana_Id + '&';
            Object.keys(this.state.searchModel).forEach(key => {
                queryString += key + "=" + this.state.searchModel[key] + "&";
            });
            queryString = queryString.slice(0, -1);
            const response = await fetch('api/paletizados' + queryString, {
                headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
            });
            const responceData = await response.json();
            responceData.forEach(row => {
                // Check for retailVariantId
                if (!row.retailVariantId || row.retailVariantId.trim() === '') {
                    row.estado = 'No hay variante asociada';
                }
                // Check for productTaraWeight
                else if (row.productTaraWeight === 0) {
                    row.estado = 'Peso con tara es 0';
                }
                // Check for productNetWeight
                else if (row.productNetWeight === 0) {
                    row.estado = 'Peso neto es 0';
                }
                // Default value if none of the conditions match
                else {
                    row.estado = '';
                }
            });
            console.log(responceData)
            this.setState({ data: responceData, loading: false });
        });
    }

   
    handleSearchChange(event) {
        event.preventDefault();
        var searchModel = this.state.searchModel;
        searchModel[event.target.name] = event.target.value;
        this.setState({ searchModel: searchModel }, () => {

        });

    }
    async modalSubmit(id) {
        if (this.state.modalOperation == 'add') {
            this.add_modal_guardar_onclick();
        }
        else if (this.state.modalOperation == 'edit') {
            this.edit_modal_guardar_onclick(id);
        }
        else if (this.state.modalOperation == 'delete') {
            this.delete_modal_guardar_onclick(id);
        }
    }
    async setVariantes_onclick() {
        const token = await authService.getAccessToken();
        const data = JSON.stringify({ semanaId: this.state.semana.semana_Id });
        const response = await fetch('api/paletizados/SetVariantes?semanaId=' + this.state.semana.semana_Id, {
            method: 'POST',
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: data
        });
        if (response.ok) {
            await this.populateData()
        }
    }
    add_modal_header() {
        return (<div><FormattedMessage id='Nuevo' /></div>);
    }
    add_modal_body() {
        return (<div><PaletizadosVariantesView setModalBodyState={this.setModalBodyState}></PaletizadosVariantesView></div>);
        //return (<div><PaletizadosVariantesView ref={this.modalBodyState}></PaletizadosVariantesView></div>);
    }
    async add_modal_guardar_onclick() {
        const token = await authService.getAccessToken();
        const data = JSON.stringify(this.modalBodyState);
        const response = await fetch('api/paletizados', {
            method: 'POST',
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: data
        });
        if (response.ok) {
            this.modalToggle();
            await this.populateData()
        }
        //const responceData = await response.json();
    }
    async edit_onclick(id) {
        const modalBody = await this.edit_modal_body(id);
        this.setState({
            modalHeader: this.edit_modal_header(id),
            modalBody: modalBody,
            modalState: true,
            modalOperation: 'edit',
        });
    }
    edit_modal_header(id) {
        return (<div><FormattedMessage id='Editar' /></div>);
    }
    async edit_modal_body(id) {
        const token = await authService.getAccessToken();
        const response = await fetch('api/paletizados/' + id, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const responceData = await response.json();
        return (<div><PaletizadosVariantesView setModalBodyState={this.setModalBodyState} data={responceData}></PaletizadosVariantesView></div>);
        //return (<div><PaletizadosVariantesView ref={this.modalBodyState}></PaletizadosVariantesView></div>);
    }
    async edit_modal_guardar_onclick() {
        const token = await authService.getAccessToken();
        const data = JSON.stringify(this.modalBodyState);
        const response = await fetch('api/paletizadosVariantes/' + this.modalBodyState.paletizadoVariante_Id, {
            method: 'PUT',
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: data
        });
        if (response.ok) {
            this.modalToggle();
            await this.populateData()
        }
    }
    async delete_onclick(id) {
        const modalBody = await this.delete_modal_body(id);
        this.setState({
            modalHeader: this.delete_modal_header(id),
            modalBody: modalBody,
            modalState: true,
            modalOperation: 'delete',
            modalIsValid: true
        });
    }
    delete_modal_header(id) {
        return (<div><FormattedMessage id='Eliminar' /></div>);
    }
    async delete_modal_body(id) {
        const token = await authService.getAccessToken();
        const response = await fetch('api/paletizados/' + id, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const responceData = await response.json();
        await this.setModalBodyState({ model: responceData });
        return (<div><PaletizadosVariantesDelete setModalBodyState={this.setModalBodyState} data={responceData}></PaletizadosVariantesDelete></div>);
    }
    async delete_modal_guardar_onclick() {
        const token = await authService.getAccessToken();
        const response = await fetch('api/paletizados/' + this.modalBodyState.paletizadoVariante_Id, {
            method: 'DELETE',
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        });
        if (response.ok) {
            this.modalToggle();
            await this.populateData()
        }
    }
    async clean_onclick() {
        this.setState({
            searchModel: { nombre: "", codigo: "" }
        });
        await this.populateData()
    }

    async setModalBodyState(state) {
        this.modalBodyState = state.model;
        if (state.modelValidation) {
            var modalIsValid = !Object.keys(state.modelValidation).some(function (val) {
                return state.modelValidation[val] == false;
            });
            this.setState({
                modalIsValid: modalIsValid
            });
        }

    }
    async load_semana() {
        var rawUrl = window.location.toString();
        var semana_Id = rawUrl.split("Semanas/")[1].split("/")[0];
        const token = await authService.getAccessToken();
        const response = await fetch('api/semanas/' + semana_Id, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        return await response.json();
    }
    async downloadReport() {
        console.log("printReport");
        await new VariantesProveedorService().VariantesProveedorReporte(this.state.semana);
        console.log("end");
    }
}